import React from 'react';
import { capitalizeFirstLetter } from '../../../../../utils/string/string';

import './IconStyleOption.css';
import { getTranslation } from '../../../../../assets/creator/translations';

const IconStyleOption = ({ iconStyle, onSelect, isCurrentIcon}) => {
    let containerClass;
    if (isCurrentIcon) {
        containerClass = "icon-style-option icon-style-option--selected";
    } else {
        containerClass = "icon-style-option icon-style-option--not-selected";
    }
    const nameKey = "Ico_"+capitalizeFirstLetter(iconStyle)+"StyleName";
    const descriptionKey = "Ico_"+capitalizeFirstLetter(iconStyle)+"StyleDescription";
    return (
        <div className={containerClass} onClick={() => onSelect(iconStyle)}>
        <img className="icon-style-option__img" src={`./img/icons/userIconStyle/user_${iconStyle}.svg`} alt="" />
        <div>
            <p className="icon-style-option__name">{getTranslation(nameKey)}</p>
            <p className="icon-style-option__colors">{getTranslation(descriptionKey)}</p>
        </div>
        </div>
    )
};

export default IconStyleOption